/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { FingerprintManager } from '.'
 * @import FingerprintBrowser from './fingerprint-uuid'
 * @import FingerprintHardware from './fingerprint-hardware'
 */

/**
 * Generátor otisku zařízení z nejlepších dostupných informací. Automaticky
 * vybere aktuálně nejlepší možnou metodu. Primárně preferuje otisk z hardwarových
 * a síťových informací. Pokud tyto informace nelze zjistit, generuje se otisk
 * z údajů o prohlížeči.
 * @implements {FingerprintManager}
 */
export default class FingerprintFallback {
  /**
   * Vytvoří instanci.
   * @param {FingerprintBrowser} browser Generátor otisku z informací, které poskytuje prohlížeč.
   * @param {FingerprintHardware} hardware Generátor otisku z hardwarových informací.
   */
  constructor(browser, hardware) {
    this.browser = browser;
    this.hardware = hardware;
  }

  /** @type {FingerprintManager['generate']} */
  async generate() {
    return await this.hardware
      .generate()
      // Pokud nelze získat informace z hardwaru, pokusíme se generovat otisk
      // z prohlížeče.
      .catch((_error) => this.browser.generate());
  }
}
